import { getData } from "./getData";
import { getPublicData } from "./getPublicData";
import { postData } from "./postData";
import { updateData } from "./updateData";
import { deleteData } from "./deleteData";
import { endpoints } from "../Utils/UrlEnum";

export interface TicketFilters {
  page?: number;
  perPage?: number;
  status?: string;
  priority?: string;
  type?: string;
  assignedTo?: string;
  clientId?: string;
  search?: string;
}

/**
 * Build query string from ticket filters
 */
const buildQueryString = (filters: TicketFilters): string => {
  const queryParams = new URLSearchParams();

  if (filters.page !== undefined) queryParams.append("page", filters.page.toString());
  if (filters.perPage !== undefined) queryParams.append("perPage", filters.perPage.toString());
  if (filters.status) queryParams.append("status", filters.status);
  if (filters.priority) queryParams.append("priority", filters.priority);
  if (filters.type) queryParams.append("type", filters.type);
  if (filters.assignedTo) queryParams.append("assignedTo", filters.assignedTo);
  if (filters.clientId) queryParams.append("clientId", filters.clientId);
  if (filters.search) queryParams.append("search", filters.search);

  const queryString = queryParams.toString();
  return queryString ? `?${queryString}` : "";
};

/**
 * Get paginated list of support tickets
 */
export const getSupportTicketsPaginated = (filters: TicketFilters = {}) => {
  const queryString = buildQueryString(filters);
  return getData(`${endpoints.supportTickets.paginated}${queryString}`);
};

/**
 * Get single support ticket by ID
 */
export const getSupportTicketById = (id: string) => {
  return getData(endpoints.supportTickets.byId(id));
};

/**
 * Create new support ticket
 */
export const createSupportTicket = (ticketData: any) => {
  return postData(endpoints.supportTickets.base, ticketData);
};

/**
 * Update support ticket
 */
export const updateSupportTicket = (id: string, ticketData: any) => {
  return updateData(endpoints.supportTickets.byId(id), ticketData);
};

/**
 * Delete support ticket (soft delete)
 */
export const deleteSupportTicket = (id: string) => {
  return deleteData(endpoints.supportTickets.byId(id));
};

/**
 * Assign users to ticket
 */
export const assignUsersToTicket = (id: string, userIds: string[]) => {
  return postData(endpoints.supportTickets.assign(id), { userIds });
};

/**
 * Update ticket status
 */
export const updateTicketStatus = (id: string, status: string, comment?: string) => {
  return postData(endpoints.supportTickets.updateStatus(id), { status, comment });
};

/**
 * Add comment to ticket
 */
export const addTicketComment = (id: string, comment: string) => {
  return postData(endpoints.supportTickets.addComment(id), { comment });
};

/**
 * Get ticket history
 */
export const getTicketHistory = (id: string) => {
  return getData(endpoints.supportTickets.history(id));
};

/**
 * Get ticket by public token (no auth required)
 */
export const getTicketByPublicToken = (token: string) => {
  return getPublicData(endpoints.supportTickets.preview(token));
};
